import { Controller } from "@hotwired/stimulus"

// Enables the final "Delete my account" button only once the user has typed
// their exact account email. The server re-verifies the match, so this is a
// UX guard, not a security boundary.
export default class extends Controller {
  static values = { email: String }
  static targets = ["input", "button"]

  declare readonly emailValue: string
  declare readonly inputTarget: HTMLInputElement
  declare readonly buttonTarget: HTMLButtonElement

  validate() {
    const typed = this.inputTarget.value.trim().toLowerCase()
    const expected = this.emailValue.trim().toLowerCase()
    this.buttonTarget.disabled = expected === "" || typed !== expected
  }
}
